import {gql} from "@apollo/client";

export const GENERATE_PARCEL_DOWNLOAD_REPORT_FOR_CS = gql`
    mutation GenerateParcelDownloadReportForCs($filters: OrderFiltersTypeInput, $timezone: String) {
        generateParcelDownloadReportForCs(filters: $filters, timezone: $timezone)
    }
`;

export interface GenerateParcelDownloadReportForCsResponse {
    generateParcelDownloadReportForCs: string;
}

export interface GenerateParcelDownloadReportVariables {
    filters?: any;
    timezone?: string;
}
